// Mirror of CssfPdfUserInformation.jsx: 30/70 row with a right-aligned label and
// the candidate name (+ current employer unless experience is hidden).

import { AlignmentType } from "docx";
import { getInitials } from "../../../../utils/getInitials";
import { para, run, twoColumnRow } from "../../shared/wordHelpers";
import { CSSF_ACCENT, CSSF_TEXT, FONT_VERDANA } from "../../shared/wordTheme";
import { pxToPt, pxToTwips } from "../../shared/wordUnits";

export function buildCssfUserInformation( { data, props } ) {
    const { user, experiences } = data;
    const { isAnonymous, isExperienceHidden } = props;

    const name = isAnonymous
        ? `${ getInitials( user?.firstName ) } ${ getInitials( user?.lastName, true ) }`
        : `${ user?.firstName ?? "" } ${ user?.lastName ?? "" }`;

    const left = [ para(
        run( "INFORMATION PERSONNELLE", { pt: pxToPt( 9 ), color: CSSF_ACCENT, font: FONT_VERDANA } ),
        { alignment: AlignmentType.RIGHT, spacing: { before: pxToTwips( 4 ), after: 0 } }
    ) ];

    const right = [ para( run( name, { pt: pxToPt( 13 ), color: CSSF_TEXT, font: FONT_VERDANA } ), { spacing: { after: 0 } } ) ];
    if ( !isExperienceHidden ) {
        right.push( para(
            run( experiences?.[ 0 ]?.employer, { pt: pxToPt( 9 ), color: CSSF_TEXT, font: FONT_VERDANA } ),
            { spacing: { before: pxToTwips( 8 ), after: 0 } }
        ) );
    }

    return [ twoColumnRow( left, right, { rightMarginLeftPx: 12 } ) ];
}
